import { handleGetAlerts } from '@domain/alert/alert.state';
import { ObjectSelectedEnum } from '@domain/object-selected/object-selected.types';
import { UPDATE_OBJECT_SELECTED } from '@domain/_redux/pareto-ads-app-redux/action/actionTypes';
import { createMiddleware } from '@shared/redux';
import gaTrackerEvent from '@shared/utils/analyticsTracker';
import { changeSelectedClient } from '@shared/utils/entity';
import { getLocation } from 'connected-react-router';

import { CREATE_CLIENT_REQUEST_SUCCEEDED } from './platform-selector.state';

export const platformSelectorMiddlewares = createMiddleware({
    [UPDATE_OBJECT_SELECTED]: (state, action) => {
        const { data } = action.objectSelected;

        const key = data.type.toLocaleLowerCase() === ObjectSelectedEnum.Account.toLocaleLowerCase()
            ? 'account_id' : 'client_id';
        const scopePath = getLocation(state).pathname.split('/');
        const page = scopePath[scopePath.length - 1];

        return [
            handleGetAlerts({
                [key]: data.id,
                page,
            }),
        ];
    },
    [CREATE_CLIENT_REQUEST_SUCCEEDED]: (state, action) => {
        const { data } = action.payload;

        gaTrackerEvent('accountSelector', 'createAccount', `${data.name}`);

        changeSelectedClient(data.id, 'client', () => {
            window.location.href = '/company';
        });
    },
});
